var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHarddiskYellow = function SvgHarddiskYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.731 11.236c.927 0 1.677-.74 1.677-1.651 0-.912-.75-1.651-1.677-1.651-.926 0-1.677.739-1.677 1.65 0 .913.751 1.652 1.677 1.652z",
    fill: "#F9D24B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.981 1.8C1.825 3.452.627 5.575.148 8.17c-.48 2.594.24 4.953 1.677 7.076 1.437 2.123 3.833 3.302 6.23 3.774 2.635.472 5.03-.236 7.187-1.651 1.198-.944 2.156-1.887 2.875-2.83l-3.115-1.18-1.437 1.415c-1.438.944-3.115 1.416-4.792 1.18-1.917-.472-3.354-1.18-4.313-2.595-.24-.236-.24-.472-.479-.708-1.437-2.83-.719-6.369 1.917-8.256 2.875-2.123 6.948-1.415 9.104 1.416.959 1.179 1.438 2.83 1.198 4.481l3.115 1.18V11c.24-2.123 0-4.246-.959-5.897-.239-.472-.479-.708-.718-1.18C14.283-.323 8.294-1.267 3.98 1.8z",
    fill: "#F9D24B"
  })));
};
export default SvgHarddiskYellow;